import type { ColDef, ColGroupDef } from '@uturn/ui-kit';

export function isColGroupDef(obj: ColGroupDef | ColDef): obj is ColGroupDef {
	return (obj as ColGroupDef).groupId !== undefined;
}

export function isColDef(obj: ColGroupDef | ColDef): obj is ColDef {
	return (obj as ColDef).colId !== undefined;
}
